import type { SettingsOptions } from "@/common/types/settingsOptions";
import { referenceClient } from "@/lib/orpc/client";

export const getSettingsOptions = (): Promise<SettingsOptions> =>
  referenceClient.settingsOptions({});
